/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Emptytree1Inputs */

const zh_course_emptytree1 = /** @type {(inputs: Course_Emptytree1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这个课程还没有内容`)
};

const en_course_emptytree1 = /** @type {(inputs: Course_Emptytree1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This course has no content yet`)
};

const es_course_emptytree1 = /** @type {(inputs: Course_Emptytree1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este curso aún no tiene contenido`)
};

/**
* | output |
* | --- |
* | "This course has no content yet" |
*
* @param {Course_Emptytree1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_emptytree1 = /** @type {((inputs?: Course_Emptytree1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Emptytree1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_emptytree1(inputs)
	if (locale === "en") return en_course_emptytree1(inputs)
	return es_course_emptytree1(inputs)
});
export { course_emptytree1 as "course_emptyTree" }